module.exports = __webpack_public_path__ + "static/media/ipswich_bs.dd0af1cb.jpg";